export const ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9]*$/
export const EMAIL_REGEX = /^([a-zA-Z0-9_\-.]+)(\+([a-zA-Z0-9_\-.]+))?@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/g
export const RFC822_REGEX = new RegExp(`((([a-zA-Z]*\\s?[a-zA-Z]*\\s?)<*${EMAIL_REGEX.source}>*)((,|;)?\\s?)?)`, 'g')
export const COLOR_HEX_REGEX = /^#[a-fA-f0-9]{6}|#[a-fA-F0-9]{3}$/g
export const STANDARD_PHONE_REGEX = /\+1(\d{3})(\d{3})(\d{4})(,+\d+)?/
export const GLOBAL_PHONE_REGEX = new RegExp(`^${STANDARD_PHONE_REGEX.source}$`, 'g')
export const SIMPLE_STANDARD_PHONE_REGEX = /\+1\d{10}/
export const PHONE_INPUT_WITH_EXTENSION_REGEX = /^\+1 \((\d{3})\) (\d{3})-(\d{4})(,+\d+)?$/g
export const PHONE_INPUT_REGEX = /^\+1 \((\d{3})\) (\d{3})-(\d{4})$/g
export const INTEGER_REGEX = /^\d+$/g
export const STANDARD_UUID_REGEX = /[a-fA-F0-9]+-[a-fA-F0-9]+-[a-fA-F0-9]+-[a-fA-F0-9]+-[a-fA-F0-9]+/
export const GLOBAL_UUID_REGEX = new RegExp(`${STANDARD_UUID_REGEX.source}`, 'g')
export const CHANNEL_NAME_REGEX = /^[a-zA-Z0-9][\w-]+[a-zA-Z0-9]$/
export const WHATSAPP_INVALID_SPACES_REGEX = /((\n+\t?( {4,})?)|(\n?\t+( {4,})?)|(\n?\t?( {4,})+))+/g
export const CUSTOM_TEMPLATE_PLACEHOLDER_REGEX = /{([^{}]+)}/g
export const FLOWDOWN_MENTIONS_REGEX = /mention:(?<id>[\d\w-]+)\[(?<name>.+?)(?<!\\)\]/g
export const TEST_SPAM_REGEX = /^(?=.*\btest\w*\b).{1,9}$/i
